import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Interface for the instructor
interface IInstructorState {
	reviewCount: number
	reviews5StarCount: number
	reviews4StarCount: number
	reviews3StarCount: number
	reviews2StarCount: number
	reviews1StarCount: number
}

// Initial state
const initialState: IInstructorState = {
	reviewCount: 0,
	reviews5StarCount: 0,
	reviews4StarCount: 0,
	reviews3StarCount: 0,
	reviews2StarCount: 0,
	reviews1StarCount: 0
}

// Slice definition
export const instructorSlice = createSlice({
	name: 'instructor',
	initialState,
	reducers: {
		setReviewCount: (state, action: PayloadAction<number>) => {
			state.reviewCount = action.payload
		},
		setReview5StarCount: (state, action: PayloadAction<number>) => {
			state.reviews5StarCount = action.payload
		},
		setReview4StarCount: (state, action: PayloadAction<number>) => {
			state.reviews4StarCount = action.payload
		},
		setReview3StarCount: (state, action: PayloadAction<number>) => {
			state.reviews3StarCount = action.payload
		},
		setReview2StarCount: (state, action: PayloadAction<number>) => {
			state.reviews2StarCount = action.payload
		},
		setReview1StarCount: (state, action: PayloadAction<number>) => {
			state.reviews1StarCount = action.payload
		}
	}
})

// Export actions
export const { setReviewCount, setReview5StarCount, setReview4StarCount, setReview3StarCount, setReview2StarCount, setReview1StarCount } = instructorSlice.actions

// Export selectors
export const reviewCount = (state: RootState) => state.instructor.reviewCount
export const reviews5StarCount = (state: RootState) => state.instructor.reviews5StarCount
export const reviews4StarCount = (state: RootState) => state.instructor.reviews4StarCount
export const reviews3StarCount = (state: RootState) => state.instructor.reviews3StarCount
export const reviews2StarCount = (state: RootState) => state.instructor.reviews2StarCount
export const reviews1StarCount = (state: RootState) => state.instructor.reviews1StarCount

// Export the reducer
export default instructorSlice.reducer
